import React, { useState } from "react";
import SectionTitle from "../SectionTitle";
import { db, collection, addDoc } from "../../firebase"; // Ajusta la ruta si es necesario
import ClipLoader from 'react-spinners/ClipLoader';

import { toast } from "react-toastify";

const HotelSection = (props) => {

  const [isLoading, setIsLoading] = useState(false);  // Estado para el loader

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    seats: 1,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      // Guardar los datos en Firebase Firestore
      await addDoc(collection(db, "HAIR"), {
        name: formData.name || "",
        phone: formData.phone || "",
        seats: formData.seats || null,
        timestamp: new Date(), // Fecha de envío
      });

      // Desplazarse al elemento con id "campo-nombre"
      const elemento = document.getElementById("hair");
      if (elemento) {
        const posicion = elemento.getBoundingClientRect().top + window.scrollY; // Calcula la posición en la página
        window.scrollTo({
          top: posicion - "0", // Aplica el offset restándolo
          behavior: "smooth", // Desplazamiento suave
        });
      }
      setFormSubmitted(true);
    } catch (error) {
      toast.error('Ha habido un error en el envío', {
        position: "top-center", // Posición central superior
        autoClose: 3000, // Tiempo de duración (en milisegundos)
        hideProgressBar: true, // Mostrar barra de progreso
        closeOnClick: true, // Cierre al hacer clic
        pauseOnHover: true, // Pausa al pasar el cursor
        draggable: true, // Permitir arrastrar el toast
        progress: undefined, // Barra de progreso predeterminada
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className={`section-padding`} id="hotel">
      {/* Mostrar el loader mientras isLoading sea verdadero */}
      {isLoading && (
        <div className="loader-overlay">
          <ClipLoader color="#fff" loading={isLoading} size={50} />
        </div>
      )}
      <div className="wpo-cta-section wpo-hotel-section">
        <div className="conatiner-fluid">
          <div className="wpo-cta-item">
            <h2>Reserva del hotel</h2>
            <p className="p-0 m-0" style={{ color: 'white' }}>(Si no necesitas alojamiento en el hotel, desliza para abajo y sigue descubriendo 😉)</p>
          </div>
        </div>
      </div>


      <div class="container">
        <div class="flex mt-5 px-4">
          <div class="col-12 col-lg-6 mx-auto text-center">
            {/* Mensaje de alerta */}
            <div class="alert alert-warning" role="alert" style={{
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeeba",
              borderRadius: "5px",
              padding: "15px",
              margin: "20px 0",
              textAlign: "left"
            }}>
              <h2 className="text-center" style={{ color: "#856404", marginBottom: "10px" }}>⚠️ ¡Importante! ⚠️</h2>
              <p style={{ color: "#856404", marginBottom: "0" }}>
                Debido a un <strong>evento multitudinario</strong> en Jaén, los hoteles de la zona se están llenando rápidamente para esas fechas.
                Si no has podido reservar en el <strong>Hotel HO Ciudad de Jaén</strong>, ¡no te preocupes! Hemos buscado una segunda opción para que nadie se quede sin alojamiento.
              </p>
              <p style={{ color: "#856404", marginBottom: "0", marginTop: "10px" }}>
                Además, Contrataremos un autobús que recogerá a los invitados desde <strong> El Corte Inglés de Jaén </strong> y los llevará directamente al hotel donde se celebrará la boda.
              </p>
              <p style={{ color: "#856404", marginBottom: "0", marginTop: "10px" }}>
                Si ya has reservado en el hotel, ¡perfecto! Si no, te recomendamos buscar otras opciones de alojamiento lo antes posible o apuntarte a la segunda opción que os comentamos.
              </p>
            </div>

            <div class="card shadow p-4" style={{ 'border-radius': '10px', 'background-color': '#f8f9fa' }}>
              <h3>🚨 Hotel HO Ciudad de Jaén 🚨</h3>
              <p>Es posible que se quede libre alguna habitación en los dias antes de la boda y
                si quereis ir probando de reservar aquí os dejamos la información para poder hacerlo.  .</p>

              <div class="discount-code" style={{
                backgroundColor: "#ffffff",
                padding: "15px",
                border: "2px dashed #55aab5",
                borderRadius: "5px",
                margin: "20px 0"
              }}>
                <p class="mb-0" style={{
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  color: "#55aab5"
                }}>CÓDIGO: <strong>MARIAYCRISTIAN</strong></p>
              </div>

              <p>¿Cómo usarlo? Solo tienes que:</p>
              <ol style={{ textAlign: "center", marginLeft: "20px" }}>
                <li>
                  Entrar en el siguiente enlace:{" "}
                  <a
                    href="https://direct-book.com/properties/HOCiudadDeJaenDirect?locale=es&items[0][adults]=2&items[0][children]=0&items[0][infants]=0&currency=EUR&checkInDate=2025-06-20&checkOutDate=2025-06-22&trackPage=yes&promocode=MARIAYCRISTIAN"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#55aab5", textDecoration: "underline" }}
                  >
                    Hotel HO Ciudad de Jaén
                  </a>.
                </li>
                <li>Se abrirá la web del hotel con el descuento aplicado.</li>
                <li>Selecciona tus fechas de estancia y los huéspedes.</li>
                <li>Selecciona la habitación y reserva.</li>
              </ol>
              {/* <p>¡No esperes demasiado! Las habitaciones con descuento son limitadas. 😉</p> */}
            </div>

            <div class="card shadow p-4 mt-4" style={{ 'border-radius': '10px', 'background-color': '#f8f9fa' }}>
              <h3>🏨 Segunda opción: Hostal Estación Jaén 🏨</h3>
              <p>
                Hemos buscado una segunda opción en un <strong>hostal cercano</strong>
              </p>

              {/* Detalles del hostal */}
              <div class="hostal-details" style={{
                backgroundColor: "#ffffff",
                padding: "15px",
                border: "2px dashed #55aab5",
                borderRadius: "5px",
                margin: "20px 0"
              }}>
                <h4 style={{ color: "#55aab5", marginBottom: "10px" }}>Hostal Estación Jaén</h4>
                <p style={{ marginBottom: "0" }}>
                  📍 <strong>Ubicación:</strong> A 10 minutos del Hotel HO Ciudad de Jaén.<br />
                </p>
              </div>

              {/* Instrucciones para reservar */}
              <p>¿Cómo reservar?</p>
              <ol style={{ textAlign: "left", marginLeft: "20px" }}>
                <li>
                  Llama al siguiente número Menciona que vas a la boda de <strong>María y Cristian</strong> con el codigo: <strong>BODA10</strong> para obtener el precio especial:{" "}
                  <a
                    href="tel:+34953274614"
                    style={{ color: "#55aab5", textDecoration: "underline" }}
                  >
                    <strong>+34 953274614</strong>
                  </a>.
                </li>
                <li>
                  Entrar en el siguiente enlace:{" "}
                  <a
                    href="https://hostalestacionjaen.com/en/buscar-habitacion/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#55aab5", textDecoration: "underline" }}
                  >
                    Hostal Estación Jaén
                  </a>.
                </li>
              </ol>

              {/* Nota adicional */}
              <p style={{ marginTop: "15px", fontStyle: "italic", color: "#555" }}>
                <strong>Nota:</strong> Necesitamos que lo reviseis cuanto antes. No van a quedar plazas.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="flex mt-5 px-4">
          <div class="col-12 col-lg-6 mx-auto text-center">
            {/* <h2>🚨 ¡Atención, viajeros! 🚨</h2> */}
            {/* <p>¿Ya sabes dónde te vas a quedar en Jaén? ¡Tenemos una sorpresa para ti!</p> */}

            
          </div>
        </div>
      </div>
    </section >

  );
};

export default HotelSection;
